import { FIELD_LABELS as F } from '@/features/startups/constants';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

const S = UI_STRINGS.STARTUP_PROFILE;

/**
 * Each startup profile field's on-screen label, for the summary at the top of a panel
 * whose Save was refused (FR-189). Keyed by form field and ordered as the panels lay
 * the fields out; a field with no visible label of its own has no entry.
 */
export const STARTUP_FIELD_LABELS: Readonly<Record<string, string>> = {
  // Company details
  logoFileKey: F.logo,
  companyName: S.COMPANY_NAME,
  briefDescription: S.BRIEF_DESCRIPTION,
  sectorId: S.SECTOR,
  subsectorIds: S.SUBSECTORS,
  sectorOther: F.sectorOther,
  fundingStage: S.FUNDING_STAGE,
  yearFounded: S.YEAR_FOUNDED,
  employeeCount: F.employeeCount,
  hqCountryId: F.hqCountry,
  hqStateId: F.hqState,
  hqCityId: F.hqCity,
  recentMilestone: S.RECENT_MILESTONE,
  companyWebsiteUrl: S.COMPANY_WEBSITE,
  companyLinkedinUrl: S.COMPANY_LINKEDIN,
  // Financials
  totalRevenueRange: S.TOTAL_REVENUE,
  arr: S.ARR,
  amountRaisedToDate: S.AMOUNT_RAISED_TO_DATE,
  nondilutiveFunding: S.NONDILUTIVE_FUNDING,
  aiClassification: F.aiClassification,
  revenueModel: F.revenueModel,
  revenueGrowthRate: F.revenueGrowthRate,
  payingCustomers: F.payingCustomers,
  // Current raise
  financeSoughtLow: F.financeSoughtLow,
  financeSoughtHigh: F.financeSoughtHigh,
  instrument: S.INSTRUMENT,
  targetCloseDate: S.TARGET_CLOSE_DATE,
  valuationOrCap: S.VALUATION_OR_CAP,
  hasLeadInvestor: F.hasLeadInvestor,
  leadInvestorName: S.LEAD_INVESTOR,
  useOfFunds: F.useOfFunds,
  investorTypesSought: F.investorTypesSought,
  // Pitch materials
  pitchDeckFileKey: S.PITCH_DECK,
  pitchVideoUrl: S.PITCH_VIDEO_URL,
  // Founding team
  foundingTeam: S.FOUNDING_TEAM,
  founderFemale: F.founderFemale,
  founderUnderrepresented: F.founderUnderrepresented,
  founderUnderrepresentedCategories: F.founderUnderrepresentedCategories,
};
